import { faTimes, faBars } from '@fortawesome/pro-light-svg-icons';
import { faBallotCheck } from '@fortawesome/pro-regular-svg-icons';
import { faTh } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Drawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, Typography } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import axios from 'axios';
import clsx from 'clsx';
import { Component } from 'react';
import { isMobile } from 'react-device-detect';
import { withTranslation } from 'react-i18next';
import { Provider } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import { NotMobileSupported, UserProfileMenu } from '../common-client2/src/components';
import LogoutWarning from '../common/components/LogoutWarning';
import SettingTitle from '../common/components/UI/Title/SettingTitle';
import EBManagerArchive from '../EmploymentBillboard/Manager/Archive';
import EBManagerRequest from '../EmploymentBillboard/Manager/Requests';
import EBManagerSettings from '../EmploymentBillboard/Manager/Settings';
import { managerStore as store } from '../EmploymentBillboard/store';
import { getApp, getProduct, managerViews, productList } from '../services/productList';
import React from 'react';

const managerPortalApp = getApp('managerPortal');

const styles = (theme) => ({
    root: {
        width: '100%',
        height: '100vh',
        display: 'flex',
        position: 'relative',
    },
    fullHeight: {
        height: '100%'
    },
    textAlignCentered: {
        textAlign: 'center'
    },
    settingContainer: {
        width: '99%',
        paddingLeft: 20
    },
    drawerPaper: {
        width: 240,
        backgroundColor: '#FFFFFF',
        minWidth: '170px'
    },
    drawer: {
        flexShrink: 0,
    },
    drawerWrapper: {
        height: '100%',
    },
    navElement: {
        fontWeight: 700,
    },
    listItem: {
        padding: '16px'
    },
    listItemNoHover: {
        color: '#3A3A3A',
        fontWeight: 700,
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0)',
        }
    },
    selected: {
        color: '#0A54A2 !important',
        backgroundColor: '#EBF0FF !important'
    },
    icon: {
        fontSize: 20,
        minWidth: 38
    },
    content: {
        flexGrow: 1,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: 0,
        width: "100vw",
    },
    logoDrawer: {
        backgroundColor: '#6EA0D7',
        textAlign: 'center',
        padding: '20px',
        margin: '20px',
        border: '1px solid #6ea0d7',
        borderRadius: '3px',
        minHeight: '1px'
    },
    logoImg: {
        width: '80%'
    },
    version: {
        marginLeft: 10,
    },
    backdrop: {
        width: '100vw',
        height: '100vh',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1
    },
    topButtons: {
        display: 'flex',
        alignItems: "center",
        minHeight: 64,
        paddingLeft: 24,
        paddingRight: 24,
    },
    barsButton: {
        padding: 0,
        color: 'var(--N700)',
        '& svg': {
            width: 24,
            height: 32,
        },
    },
    titleSlot: {
        flex: 1,
        marginLeft: 20,
        marginTop: 4,
    }
});

const appIcon = {
    callList: ['fal', 'phone'],
    quotaManagement: ['fal', 'chart-pie'],
    requestCalendar: ['fal', 'calendar'],
    hcScheduleReport: ['fal', 'clock'],
    dailyShiftBidding: faBallotCheck,
    workplanManager: faTh,
    employmentBillboardRequests: ['fal', 'calendar'],
    employmentBillboardSettings: ['fal', 'cog'],
    employmentBillboardArchive: ['fal', 'archive']
}

class ManagerDashboard extends Component {
    constructor(props) {
        super(props);

        const sufix = managerViews[0];
        const productWithSufix = `${getProduct("employmentBillboard").name}${sufix}`;

        const applicationSelected = sessionStorage.getItem('appSelected') || `${productWithSufix}`;

        const jwtUserInfo = JSON.parse(sessionStorage.getItem('jwtUserInfo'));
        const initiales = sessionStorage.getItem('userInitials');
        const firstName = jwtUserInfo?.FirstName ? jwtUserInfo?.FirstName : "";
        const lastName = jwtUserInfo?.LastName ? jwtUserInfo?.LastName : "";

        this.state = {
            applicationSelected,
            extended: false,
            buildInfos: {
                version: "-",
                environment: "-"
            },
            userInfos: {
                firstName: firstName,
                lastName: lastName,
                initials: initiales,
            }
        };

        this.apps = productList?.filter((p) => p?.env.includes("manager") && p?.api === managerPortalApp.api);

        const options = {
            headers: {
                Authorization: sessionStorage.getItem('authToken') ?? '',
            }
        };
        axios.get(process.env.REACT_APP_API_DOTNET + '/api/v1/common/buildInfos', options).then(async buildInfos => {
            this.setState({ buildInfos: { ...buildInfos.data } })
        });
    }

    handleOnClickApplication = (name) => {
        this.setState({
            applicationSelected: name,
            extended: false,
        });
        sessionStorage.setItem('appSelected', name);
    }

    handleSideMenu = (event, extend) => {
        event.stopPropagation()
        this.setState({ extended: extend })
    }

    renderDrawer(classes, applicationSelected) {
        return (
            <Drawer
                className={classes.drawer}
                variant="persistent"
                classes={{ paper: classes.drawerPaper }}
                anchor="left"
                open={this.state.extended}
            >
                <div
                    className={classes.drawerWrapper}
                >
                    <div>
                        <div>
                            <IconButton onClick={(event) => this.handleSideMenu(event, false)} size="large">
                                <FontAwesomeIcon icon={faTimes} />
                            </IconButton>
                        </div>
                        <div>
                            <List>
                                {this.apps.map((app, index) => {
                                    let listItem = '';
                                    if (app.managerViews) {
                                        listItem = (
                                            <ListItem key={index} value={app.name} className={classes.listItemNoHover}>
                                                <div>
                                                    <div>
                                                        <Typography className={classes.navElement}>{this.props.t(app.name + ':settings.appName')}</Typography>
                                                    </div>
                                                    <div>
                                                        <List component="div" disablePadding>
                                                            {
                                                                app.managerViews.map((view) => (
                                                                    <ListItemButton
                                                                        classes={{ selected: classes.selected }}
                                                                        className={classes.listItemNoHover}
                                                                        key={view}
                                                                        onClick={() => { this.handleOnClickApplication(app.name + view) }}
                                                                        selected={app.name + view === applicationSelected}
                                                                    >
                                                                        <ListItemIcon
                                                                            className={clsx(classes.icon, classes.navElement, {
                                                                                [classes.selected]: app.name + view === applicationSelected
                                                                            })}
                                                                        >
                                                                            {appIcon[app.name + view] && <FontAwesomeIcon icon={appIcon[app.name + view]} />}
                                                                        </ListItemIcon>
                                                                        <Typography className={classes.navElement}>
                                                                            {this.props.t(app.name + ':settings.appNameSUB' + view)}
                                                                        </Typography>
                                                                    </ListItemButton>
                                                                ))
                                                            }
                                                        </List>
                                                    </div>
                                                </div>
                                            </ListItem>
                                        )
                                    } else {
                                        listItem = (
                                            <ListItemButton key={index} value={app.name} className={classes.listItem} classes={{ selected: classes.selected }}
                                                onClick={() => { this.handleOnClickApplication(app.name) }} selected={app.name === applicationSelected}>
                                                <ListItemIcon className={classes.icon}>
                                                    {appIcon[app.name] && <FontAwesomeIcon icon={appIcon[app.name]} className={classes.navElement} />}
                                                </ListItemIcon>
                                                <Typography className={classes.navElement}>{this.props.t(app.name + ':settings.appName')}</Typography>
                                            </ListItemButton>)
                                    }
                                    return listItem;
                                })}
                            </List>
                        </div>
                    </div>
                </div>
            </Drawer>
        );
    }

    render() {
        if(isMobile){
            return (
                <NotMobileSupported/>
            )
        }

        const { classes, t } = this.props;
        const { applicationSelected, extended, userInfos, buildInfos } = this.state;

        const appComponent = {
            employmentBillboard: <EBManagerRequest />,
            employmentBillboardSettings: <EBManagerSettings />,
            employmentBillboardRequests: <EBManagerRequest />,
            employmentBillboardArchive: <EBManagerArchive />,
        }

        const appTitles = {
            employmentBillboard: {
                title: t('employmentBillboard:settings.appNameSUBRequests'),
                subtitle: t('employmentBillboard:settings.appNameManager'),
            },
            employmentBillboardRequests: {
                title: t('employmentBillboard:settings.appNameSUBRequests'),
                subtitle: t('employmentBillboard:settings.appNameManager'),
            },
            employmentBillboardSettings: {
                title: t('employmentBillboard:settings.appNameSUBSettings'),
                subtitle: t('employmentBillboard:settings.appNameManager'),
            },
            employmentBillboardArchive: {
                title: t('employmentBillboard:settings.appNameSUBArchive'),
                subtitle: t('employmentBillboard:settings.appNameManager'),
            },
        };
        const currentTitle = appTitles[applicationSelected] || { title: '', subtitle: '' };

        const body = appComponent[applicationSelected];

        return (
            <Provider store={store}>
                <div className={classes.root}>
                    {extended ? <div className={classes.backdrop} onClick={(event) => this.handleSideMenu(event, false)}></div> : null}
                    {this.renderDrawer(classes, applicationSelected)}
                    <div className={classes.content}>
                        <div className={classes.topButtons}>
                            <IconButton onClick={(event) => this.handleSideMenu(event, true)} size="small" className={classes.barsButton}>
                                <FontAwesomeIcon icon={faBars} />
                            </IconButton>
                            <SettingTitle
                                titleText={currentTitle.title}
                                subtitleText={currentTitle.subtitle}
                                wrapperClass={classes.titleSlot}
                            />
                            <UserProfileMenu
                                fullName={`${userInfos.firstName} ${userInfos.lastName}`}
                                initials={userInfos.initials}
                                version={buildInfos.version}
                                environement={t(`environment.${buildInfos.environment}`, { ns: 'common' })}
                                labels={{
                                    sectionTitleAbout: t(`userMenu.about`, { ns: 'common' }),
                                    aboutVersion: t(`userMenu.version`, { ns: 'common' }),
                                    aboutEnvironment: t(`userMenu.environment`, { ns: 'common' })
                                }}
                            />
                        </div>
                        {body}
                    </div>
                </div>

                <ReduxToastr
                    timeOut={4000}
                    newestOnTop={false}
                    preventDuplicates
                    position="top-center"
                    transitionIn="fadeIn"
                    transitionOut="fadeOut"
                    closeOnToastrClick
                />
                <LogoutWarning />
            </Provider>
        );

    }
}

export default withTranslation(['common', 'employmentBillboard', 'hcScheduleReport', 'workplanManager', 'quotaManagement', 'requestCalendar', 'dailyShiftBidding'])(withStyles(styles)(ManagerDashboard));